import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { LockKey } from '@phosphor-icons/react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

interface AccessDeniedProps {
  landingPath?: string
}

export function AccessDenied({ landingPath = '/dashboard' }: AccessDeniedProps) {
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  const { locale } = useParams<{ locale: string }>()
  const currentLocale = locale || 'en'

  return (
    <div className="flex min-h-[60vh] w-full items-center justify-center px-4 py-12">
      <Card className="w-full max-w-md border-[var(--pd-border)] bg-[var(--pd-card)]">
        <CardContent className="flex flex-col items-center gap-4 py-10 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[var(--pd-danger)]/10 text-[var(--pd-danger)]">
            <LockKey size={28} weight="bold" />
          </div>
          <div className="space-y-1.5">
            <h2 className="text-lg font-semibold text-[var(--pd-foreground)]">
              {t('accessDenied.title')}
            </h2>
            <p className="text-sm text-[var(--pd-foreground)]/65">
              {t('accessDenied.description')}
            </p>
          </div>
          <Button
            onClick={() => navigate(`/${currentLocale}${landingPath}`)}
            className="mt-2 bg-[var(--pd-primary)] text-white hover:bg-[var(--pd-primary)]/90"
          >
            {t('accessDenied.backToDashboard')}
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
